
import React from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Calendar } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { formatDate } from "@/utils/dateUtils";
import SwapRequestStatusBadge from "./SwapRequestStatusBadge";
import RequestedReagentCard from "./RequestedReagentCard";
import RequesterInfoCard from "./RequesterInfoCard";
import OfferedItemCard from "./OfferedItemCard";
import MessageCard from "./MessageCard";
import { SwapRequest } from "@/services/myReagents/types";

interface SwapRequestDetailsProps {
  swapRequest: SwapRequest;
}

const SwapRequestDetails: React.FC<SwapRequestDetailsProps> = ({ swapRequest }) => {
  // Make sure reagent data exists and is properly typed
  const reagentData = typeof swapRequest.reagents === 'object' && swapRequest.reagents 
    ? swapRequest.reagents 
    : { name: "Unknown Reagent", catalogue_number: null, amount: null, amount_unit: null };

  return (
    <Card>
      <CardHeader className="pb-4">
        <div className="flex justify-between items-start">
          <CardTitle className="text-2xl font-semibold">Swap Request</CardTitle>
          <SwapRequestStatusBadge status={swapRequest.status} />
        </div>
      </CardHeader>
      
      <CardContent className="space-y-6">
        <div className="flex items-center space-x-2 text-muted-foreground">
          <Calendar className="h-4 w-4" />
          <span>Requested on {formatDate(swapRequest.created_at)}</span>
        </div>
        
        <Separator />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <RequestedReagentCard reagentData={reagentData} />
          <RequesterInfoCard profile={swapRequest.profiles} />
        </div>
        
        <Separator />
        
        <OfferedItemCard 
          creditOffer={swapRequest.credit_offer}
          offeredReagent={swapRequest.offered_reagent}
          offeredReagents={swapRequest.offered_reagents}
        />
        
        <MessageCard message={swapRequest.message} />
      </CardContent>
    </Card>
  );
};

export default SwapRequestDetails;
